<style scoped>
.gray-bg {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.no-bottom-radius {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>

<template>
  <div>
    <anchor-right-content v-if="includeTopContent" container-classes="mx-0 my-3">
      <slot name="top-content" />
    </anchor-right-content>
    <v-card flat :outlined="outlined">
      <slot name="title">
        <v-card-title v-if="title" class="subtitle-2 font-weight-medium gray-bg py-2 radio no-bottom-radius">
          {{ title }}
          <v-spacer />
          <slot name="title-helper" />
        </v-card-title>
      </slot>

      <slot />
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AnchorCardBaseView',
  props: {
    includeTopContent: Boolean,
    title: String,
    outlined: Boolean,
  },
};
</script>
